
<template>
    <div id="listVendorPayment">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div class="right-invoice-tab-list workorder-right-sidebar invoice-list-sidebar hide" id="check-detail-section">
            <div class="containerTab">
                <a href="javascript:void(0)" class="closebtn" v-on:click="closeCheckPreview()">×</a>
                <div class="content">
                    <template v-if="canPay">
                        <template v-if="selectedStatus == 'pending'">
                            <div class="col-sm-6">
                                <!-- <button type="button" class="btn btn-primary pull-left" id="confirmStatusBtnPreview" v-on:click="changeStatus('preview','confirmed')">Confirm</button> -->
                                <button type="button" class="btn btn-primary pull-left" id="cancelStatusBtnPreview" v-on:click="removePayment('preview')">Remove</button>
                            </div>
                        </template>
                        <template v-else-if="selectedStatus == 'confirmed'">
                            <div class="col-sm-6 status-btn-space">
                                <button type="button" class="btn btn-primary pull-left" id="voidStatusBtnPreview" v-on:click="openReasonModal('cancel')">Cancel</button>
                            </div>
                        </template>
                    </template>

                    <p>&nbsp;</p>
                    <!-- <iframe :src="path+'/Check Payment Demo.pdf'"  title="" width="95%" height="500px" id="checkPreview"></iframe> -->
                    <iframe v-if="path != ''" :src="path" width="95%"  title="" height="500px" id="checkPreview"></iframe>
                </div>
            </div>
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> AP Payment Listing</div>
                    <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                    <div class="btn-groups text-right">
                        <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportCheck()">
                            <i class="fp-export"></i> Export
                        </a>
                        <a href="javascript:void(0)" class="btn btn-primary" v-on:click="openExportModal()">
                            <i class="fp-accounting"></i> Positive Pay
                        </a>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content vendor-payment-list">
                        <data-table-filter-config :moduleName="'listVendorPayment'" ref="filterPaymentList" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <div class="form-row">
                            <div class="left-payment-list col-md-3" v-if="showPaymentTagSection">
                                <ul class="top-link-section">
                                    <li> <a href="javascript:void(0);" class="closed color-blue" @click="openLeftPaymentTagAdd">  <i class="fp-plus mr-1"> </i>  Add </a> </li>
                                    <li class="color-blue">&nbsp;&nbsp; | &nbsp;&nbsp;</li>
                                    <template v-if="showResetBtn">
                                        <li> <a href="javascript:void(0);" class="closed color-blue" @click="resetTagList"> <i class="fp-refresh"> </i> Reset </a> </li>
                                    </template>
                                    <template v-else>
                                        <li> <a href="javascript:void(0);" class="closed color-blue" @click="openLeftPaymentTagSearch"> <i class="fp-search font-1 mr-1"> </i> Search </a> </li>
                                    </template>
                                    <li class="pull-right"> <a href="javascript:void(0);" class="closed" @click="hidePaymentTagDiv"> <i class="fp-back"> </i> Back </a> </li>
                                </ul>
                                <div class="open-input-box-section hide bg-white" id="addPaymentTagLeft">
                                    <div class="form-row">
                                        <div class="col form-group">
                                            <input type="text" v-model="tag_input_left" name="tag_input_left" id="tag_input_left" class="form-control" placeholder="Tag Name">
                                            <div class="field-error">{{tag_input_left_error_msg}}</div>
                                        </div>

                                    </div>
                                    <div class="btn-groups text-right font-1">
                                        <a href="javascript:void(0);" class="active color-blue mr-2" v-on:click.prevent="savePaymentTagLeft()"> Save </a>
                                        <a href="javascript:void(0);" @click="closeLeftPaymentTagAdd"> Close </a>
                                    </div>
                                </div>
                                <div class="open-input-box-section hide bg-white" id="searchPaymentTagLeft">
                                    <div class="form-row">
                                        <div class="col form-group">
                                            <input type="text" v-model="search_input_left" name="search_input_left" id="search_input_left" class="form-control" placeholder="Tag Name">
                                            <div class="field-error">{{search_input_left_error_msg}}</div>
                                        </div>
                                    </div>
                                    <div class="btn-groups text-right font-1">
                                        <a href="javascript:void(0);" class="active color-blue mr-2" v-on:click.prevent="searchPaymentTagLeft()"> Search </a>
                                        <a href="javascript:void(0);" @click="closeLeftPaymentTagSearch"> Close </a>
                                    </div>
                                </div>
                                <div id="custom-scrollbar" class="bottom-list-section cashflow-listing-fl custom-scrollbar">
                                    <template v-if="paymentTagsRows.length > 0">
                                        <template v-for="(paymentTag,ind) in paymentTagsRows">
                                            <!--isDraggable to handle Drop component cannot be dragged -->
                                            <drop v-show="isDraggable" class="drop" @dragenter="handleDragEnter" @dragover="handleDragOver(paymentTag,ind)" @dragleave="handleDragLeave(paymentTag,ind)" @drop="handleDrop" :key="ind">
                                                <a v-bind:class="{'list-detail-section':defaultClass,'tag-border-red':paymentTag.setRed,'tag-border-green':paymentTag.setGreen,'highlight-list':paymentTag.setOver,'active':paymentTag.setActive}" href="javascript:void(0);" :id="'tag-item' + paymentTag.tagId" @click="onTagClick(paymentTag.tagName,ind)">
                                                    <h6>{{paymentTag.tagName}}</h6>
                                                    <p> {{paymentTag.totalAmount}} | Payments : {{paymentTag.totalPayments}} | Vendors : {{paymentTag.totalVendor}} </p>
                                                </a>
                                            </drop>
                                            <a :key="ind+'btn'" class="btn btn-success waves-effect pull-right" v-if="ind == paymentTagsRows.length - 1 && ind < tagsTotalRecords - 1" href="javascript:void(0)" v-on:click="loadMoreData()"> Load More</a>
                                        </template>
                                    </template>
                                    <template v-else>
                                        <a class="list-detail-section" href="javascript:void(0);">
                                            <h6> No Data Found. </h6>
                                        </a>
                                    </template>
                                </div>
                            </div>
                            <div id="payment-list-section" :class="paymentListClass == ''? 'col-md-12': paymentListClass">
                            <div class="data-table bg-white overflow-hidden">
                              <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                              <section class="data-table bg-white">
                                    <custom-pagination
                                            :page-changed="onPageChange"
                                            :per-page-changed="onPerPageChange" :position="'top'"
                                            :moduleName="'listVendorPayment'" ref="paginateComponent">
                                    </custom-pagination>

                                    <vue-good-table
                                            ref="listVendorPaymentTable"
                                            mode="remote"
                                            title="Vendor Payment"
                                            @on-page-change="onPageChange"
                                            @on-sort-change="onSortChange"
                                            @on-column-filter="onColumnFilter"
                                            @on-per-page-change="onPerPageChange"
                                            @on-selected-rows-change="selectionChanged"
                                            @on-select-all="onSelectAll"
                                            :totalRows="totalRecords"
                                            :columns="userColumns"
                                            :rows="rows"
                                            :paginationOptions="{
                                            enabled: false,
                                            position: 'both',
                                            perPage: perPage,
                                            perPageDropdown:dropDownPerPage,
                                            dropdownAllowAll: false

                                        }"
                                        :select-options="{
                                            enabled: canPay,
                                            selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                            selectionInfoClass: 'custom-class',
                                            selectionText: 'rows selected',
                                            clearSelectionText: 'clear',
                                        }"
                                            :search-options="{
                                        enabled: false,
                                        }"
                                            :sort-options="{
                                        enabled: true,
                                        }"
                                    >
                                        <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                            <div :key="key">
                                                <!-- <template v-if="props.column.field == 'cheque'">
                                                    <a href="javascript:void(0)" title="View Check" v-on:click="openCheckPreview(props.row.status,props.row.id,props.row.file_path,props.row.check_type)" class="color-blue" >
                                                        <template v-if="props.row.status.toLowerCase() == 'pending'">
                                                            View
                                                        </template>
                                                        <template v-else>
                                                            {{props.row.cheque}}
                                                        </template>
                                                    </a>
                                                </template> -->
                                                <div v-if="props.column.field == 'payment_number'" class="drag-icon">
                                                    <template v-if="canView">
                                                        <drag class="drag" @dragstart="handleDragStart" @dragend="handleDragEnd" :transfer-data="props.row">
                                                            <i v-if="showPaymentTagSection" class="fp-drag-icon drag-icon checkbox-custome-fl mr-2 pull-left" style="margin-left:-5px;font-size:14px"></i>
                                                            <!-- <img v-if="showPaymentTagSection" class="drag-icon checkbox-custome-fl mr-2 pull-left" src="/static/images/dragicon.png" alt="Fleetpro" height="15" width="15" style="margin-left:-5px;"> -->
                                                            <div slot="image" class="drag-image bg-white p-3" v-if="showPaymentTagSection">
                                                                    <div class="form-row form-group">
                                                                        <label class="col">#Payment :</label>
                                                                        <span class="col">{{props.row.payment_number}}</span>
                                                                    </div>
                                                                    <div class="form-row form-group">
                                                                        <label class="col">#Tag :</label>
                                                                        <span class="col" v-if="props.row.payment_tag != null && props.row.payment_tag != ''">{{props.row.payment_tag}}</span>
                                                                        <span class="col" v-else>-</span>
                                                                    </div>
                                                                    <div class="form-row form-group">
                                                                        <template v-if="props.row.check_type == 'ch'">
                                                                            <label class="col">#Check :</label>
                                                                        </template>
                                                                        <template v-else>
                                                                            <label class="col">#ACH :</label>
                                                                        </template>
                                                                        <span class="col" v-if="props.row.cheque != null">{{props.row.cheque}}</span>
                                                                        <span class="col" v-else>-</span>
                                                                    </div>
                                                                    <div class="form-row form-group">
                                                                        <label class="col">Vendor :</label>
                                                                        <span class="col">{{props.row.vendor}}</span>
                                                                    </div>
                                                                    <div class="form-row form-group">
                                                                        <label class="col">Date :</label>
                                                                        <span class="col">{{props.row.payment_date}}</span>
                                                                    </div>
                                                                    <div class="form-row form-group">
                                                                        <label class="col">Status :</label>
                                                                        <span class="col">{{props.row.status}}</span>
                                                                    </div>
                                                                    <div class="form-row form-group">
                                                                        <label class="col">Amount :</label>
                                                                        <span class="col">{{props.row.amount}}</span>
                                                                    </div>
                                                            </div>
                                                        </drag>
                                                        <router-link title="View Vendor Payment" class="drag-icon-payment-link color-blue" v-bind:to="{name: 'VendorPaymentView',params:{id:props.row.id}}">{{props.row.payment_number}}</router-link>
                                                    </template>
                                                </div>
                                                <div v-else-if="props.column.field == 'action'">
                                                    <a v-if="canViewLog" v-on:click.prevent="getActivityLogInfo(props.row.id)" class="fp-view" href="javascript:void(0)"></a>
                                                </div>
                                                <div v-else>
                                                    {{props.formattedRow[props.column.field]}}
                                                </div>
                                            </div>
                                        </template>
                                        <div slot="selected-row-actions">
                                            <template v-if="canPay">
                                                <button v-if="showConfirmBtn" id="confirmPaymentBtn" v-on:click.prevent="changeStatus('list','confirmed')" class="btn btn-primary">Confirm</button>
                                                <button v-if="showReassignBtn" id="showReassignBtn" v-on:click.prevent="openReasonModal('reassign')" class="btn btn-primary">Reassign Check/ACH</button>
                                                <button v-if="showPrintBtn" id="printPaymentBtn" v-on:click.prevent="changeStatus('list','printed')" class="btn btn-secondary">Print</button>
                                                <button v-if="showSendEmailBtn" id="sendEmailPaymentBtn" v-on:click.prevent="sendConfirmedPayments" class="btn btn-secondary">Send Email</button>
                                                <button v-if="showRemoveBtn" id="deletePaymentBtn" v-on:click.prevent="removePayment('list')" class="btn btn-secondary">Remove</button>
                                                <button v-if="showCancelBtn" id="voidPaymentBtn" v-on:click.prevent="openReasonModal('void')" class="btn btn-secondary">Void</button>
                                                <!-- No need this button as we are settle the payment from bank rec screen -->
                                                <!-- <button v-if="showCloseBtn" id="closePaymentBtn" class="btn btn-tertiary" v-on:click="closePayment()">Close </button> -->
                                                <button id="updateDate" v-on:click.prevent="openPaymentModal('date')" class="btn btn-primary">Update Date</button>
                                                <button id="removeTagBtn" class="btn btn-secondary" v-on:click="removePaymentTag()">Remove Tag </button>
                                                <button id="chequePreview" class="btn btn-secondary" v-on:click="openMultipleCheckPreview()"> Preview/Print </button>
                                            </template>
                                        </div>

                                    </vue-good-table>
                                    <custom-pagination
                                            :page-changed="onPageChange"
                                            :per-page-changed="onPerPageChange">
                                    </custom-pagination>

                              </section>
                            </div>
                            <div class="modal fade change-status-modal" id="change-status-modal" ref="changeStatusModal" data-backdrop="static" data-keyboard="false" aria-labelledby="changeStatusModal" aria-hidden="true">
                                        <div class="modal-dialog modal-lg" role="document">
                                            <div class="modal-content">
                                                <div class="modal-header">
                                                    <h5 class="modal-title">Select Status</h5>
                                                    <button type="button" class="close" id="btnModalClose" v-on:click="hideModal()">&times;</button>
                                                </div>
                                                <div class="modal-body">
                                                    <template v-if="canPay">
                                                        <template v-if="selectedStatus == 'pending'">
                                                            <button type="button" class="btn btn-primary " id="removeBtn">Remove</button>
                                                        </template>
                                                        <template v-else-if="selectedStatus == 'confirmed'">
                                                            <button type="button" class="btn btn-primary" id="voidStatusBtn" v-on:click="openReasonModal('void')">Void</button>
                                                        </template>
                                                    </template>
                                                </div>
                                            </div>
                                        </div>
                            </div>
                            <div class="modal fade void-reason-modal" id="void-reason-modal" ref="voidReasonModal" data-backdrop="static" data-keyboard="false" aria-labelledby="voidReasonModal" aria-hidden="true">
                                <div class="modal-dialog modal-lg" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header">
                                            <h5 class="modal-title">Please Enter Reason</h5>
                                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                                        </div>
                                        <div class="modal-body">
                                            <div class="form-row">
                                                <div class="col form-group">
                                                    <textarea class='form-control rounded-0' v-model="reason" ref="textarea" id="reason" rows="3"></textarea>
                                                    <div class="field-error">{{reason_error_msg}}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="modal-footer">
                                            <button class="btn btn-primary" id="submitReasonBtn" v-on:click="submitReason()"> Submit </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="modal fade invoice-modal customer-activity-modal" id="paymentactivityLogViewModal" ref="paymentactivityLogViewModal" data-backdrop="static" data-keyboard="false" aria-labelledby="invModal" aria-hidden="true">
                                <div class="modal-dialog modal-lg" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header">
                                            <h5 class="modal-title">Activity Log</h5>
                                        </div>
                                        <div class="modal-body">
                                            <div class="col-xs-12 customer-view-activity-log">
                                                <div class="row">
                                                    <div class="activity-log-main">
                                                        <div class="activity-label limit-width"> <p> Label </p> </div>
                                                        <div class="activity-value limit-width"> <p> Current Value </p> </div>
                                                        <div class="activity-value-prev limit-width"> <p> Old Value </p> </div>
                                                        <div class="activity-value-prev limit-width"> <p> Changed By </p> </div>
                                                    </div>
                                                    <template v-for="(fields, labels) in fieldArr">
                                                        <div v-bind:key="labels">
                                                            <template v-for="(field, label) in fields">
                                                            <div class="activity-log-internal" v-bind:key="label">
                                                                <div class="activity-label limit-width"> <p> {{ ucStringValue(label) }} </p> </div>
                                                                <div class="activity-value limit-width"> <p> {{ ucStringValue(field.new_value) }} </p> </div>
                                                                <div class="activity-value-prev limit-width"> <p> {{ ucStringValue(field.old_value) }} </p> </div>
                                                                <div class="activity-value limit-width"> <p v-if="userArr[labels] && userArr[labels] != undefined"> {{ ucStringValue(userArr[labels]) }} </p> </div>
                                                            </div>
                                                            </template>
                                                        </div>
                                                    </template>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="modal-footer">
                                            <button type="button" class="btn btn-tertiary" data-dismiss="modal" > <i class="fp-close"> </i> Cancel</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="modal fade make-payment-modal" id="updatePaymentModal" ref="updatePaymentModal" data-backdrop="static" data-keyboard="false" aria-labelledby="makePaymentModal" aria-hidden="true">
                                <div class="modal-dialog modal-lg" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header">
                                            <h5 class="modal-title">{{updatePayment}}</h5>
                                            <button type="button" class="close" id="btnPaymentModalClose" v-on:click="hidePaymentModal()">&times;</button>
                                        </div>
                                        <div class="modal-body">
                                            <div class="form-row">
                                                <template v-if="tagUpdate">
                                                    <template v-if="showTagSearchField">
                                                        <div class="col-md-6 form-group">
                                                            <label class="control-label" for="payment_tag"> Tag:</label>
                                                            <v-select v-model="payment_tag" name="payment_tag"
                                                                label="text" :filterable="false" :options="paymentTagsArr"
                                                                @search="onSearchPaymentTag"
                                                                placeholder="Select Tag" class="custom-ci-auto-search">
                                                                <template slot="no-options">
                                                                    Search Tag...
                                                                </template>
                                                                <template slot="option" slot-scope="option">
                                                                    <div class="d-center">
                                                                        {{ option.text }}
                                                                    </div>
                                                                </template>
                                                                <template slot="selected-option" slot-scope="option">
                                                                    <div class="selected d-center">
                                                                        {{ option.text }}
                                                                    </div>
                                                                </template>
                                                            </v-select>
                                                        </div>
                                                        <div class="col-sm-3 form-group">
                                                            <label class="control-label">&nbsp;</label>
                                                            <button class="btn btn-primary" id="btnAddTagModal" v-on:click="showTagInput()"><i class="fp-add"> </i> Tag </button>
                                                        </div>
                                                    </template>
                                                    <template v-else>
                                                        <div class="col-sm-6 form-group">
                                                            <label class="control-label" for="tag_input"> Tag Name:</label>
                                                            <input type="text" class="form-control" v-model="tag_input" id="tag_input" placeholder="Enter Tag Name" name="tag_input">
                                                            <div class="field-error">{{tag_input_error_msg}}</div>
                                                        </div>
                                                        <div class="col-sm-3 form-group">
                                                            <label class="control-label">&nbsp;</label>
                                                            <button class="btn btn-primary" id="btnSaveTagModal" v-on:click="savePaymentTag()"><i class="fp-save"></i> Save </button>
                                                        </div>
                                                    </template>
                                                </template>
                                                <template v-if="dateUpdate">
                                                    <div class="col-xs-12 col-sm-4 col-md-4 col-lg-6 form-group">
                                                        <label class="control-label require" for="payment_date">Payment Date:</label>
                                                        <div class="input-group">
                                                            <date-picker placeholder="MM/DD/YYYY" id="payment_date" name="payment_date" v-model="payment_date" :config="optionsDate"></date-picker>
                                                            <label for="payment_date" class="fp-calendar input-calender-icon"></label>
                                                        </div>
                                                        <div class="field-error">{{ payment_date_error }}</div>
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                        <div class="modal-footer">
                                            <button class="btn btn-primary" id="btnPaymentModalProcess" v-on:click="updatePaymentTag()"> Update </button>
                                            <button class="btn btn-primary" id="btnPaymentModalCancel" v-on:click="hidePaymentModal()"> Cancel </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="modal fade positive-export-modal" id="positive-export-modal" ref="positiveexportModal" data-backdrop="static" data-keyboard="false" aria-labelledby="positiveexportModal" aria-hidden="true">
                                <div class="modal-dialog modal-lg" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header">
                                            <h5 class="modal-title">Select Month</h5>
                                            <button type="button" class="close" id="btnModalClose" v-on:click="hidePaymenExporttModal()">&times;</button>
                                        </div>
                                        <div class="modal-body">
                                            <div class="form-row">
                                                <div class="col-xs-12 col-sm-4 col-md-4 col-lg-6 form-group">
                                                    <label class="control-label require" for="month">Select Month:</label>
                                                    <div class="input-group">
                                                        <date-picker placeholder="MM/YYYY" id="month" name="month" v-model="month" :config="optionsMonths"></date-picker>
                                                        <label for="month" class="fp-calendar input-calender-icon"></label>
                                                    </div>
                                                    <div class="field-error">{{ month_error_msg }}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="modal-footer">
                                            <button class="btn btn-secondary" id="Exportbtn" v-on:click="exportPayment()"> Export </button>
                                            <button class="btn btn-tertiary" id="CancelBtn" v-on:click="hidePaymenExporttModal()"> Cancel </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>

            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>

<script>

    import Vue from 'vue';

    
    


    import EventBus from ".././event-bus";
    import {commonMixins} from '../../mixins/commonMixins';
    import {dataTableMixins} from '../../mixins/dataTableMixins';
    import { Drag, Drop } from 'vue-drag-drop';

    var contex
    export default {
        name: "VendorPaymentList",
        metaInfo: {
            // title will be injected into parent titleTemplate
            title: "AP Payment Listing  | " +process.env.COPYRIGHT_NAME
        },
        components: {
            
            
            
            Drag,
            Drop,
        },
        mixins:[commonMixins,dataTableMixins],

        data: () => ({
            commentFor: "",
            firstLoad: 0,
            userRole:"",
            invoiceArr:[],
            invoices:[],
            permissions: [],
            userColumns:[],
            updatePayment:'',
            columns: [
                {
                  label: "Vendor Number",
                  field: "vendor_code",
                  filterable: true,
                  fpFieldType:"text",
                  hidden:false,
                  filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Vendor Number", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                  }
                },
                {
                  label: "Vendor Name",
                  field: "vendor",
                  fpFieldType:"text",
                  filterable: true,
                  hidden:false,
                  filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Vendor Name", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                  }
                },
                {
                  label: "Bank Code",
                  field: "bank_code",
                  fpFieldType:"text",
                  filterable: true,
                  hidden:false,
                  filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Bank Code", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                  }
                },
                {
                  label: "Pmt Type",
                  field: "payment_type",
                  fpFieldType:"text",
                  filterable: true,
                  hidden:false,
                  filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Payment Type", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                  }
                },
                {
                    label: "Payment Number",
                    field: "payment_number",
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Payment Number", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                // {
                //     label: "#Check",
                //     field: "cheque",
                //     fpFieldType:"text",
                //     filterable: true,
                //     hidden:false,
                //     filterOptions: {
                //         enabled: false, // enable filter for this column
                //         placeholder: "Check", // placeholder for filter input
                //         filterValue: '', // initial populated value for this filter
                //         filterDropdownItems: [], // dropdown (with selected values) instead of text input
                //         filterFn: this.onColumnFilter, //custom filter function that
                //         trigger: "enter" //only trigger on enter not on keyup
                //     }
                // },
                {
                    label: 'Payment Date',
                    field: 'payment_date',
                    filterable: true,
                    fpFieldType:"date",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                  label: "Payment Amount",
                  field: "amount",
                  fpFieldType:"integer",
                  filterable: true,
                  type:'number',
                  hidden:false,
                  filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Amount", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                  }
                },
                {
                  label: "Curr Cd",
                  field: "currency_code",
                  fpFieldType:"text",
                  filterable: false,
                  hidden:false,
                },
                {
                  label: "Status",
                  field: "status",
                  filterable: true,
                  fpFieldType:"option",
                  hidden:false,
                  filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "status", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                  }
                },
                {
                  label: 'Cleared Date',
                  field: 'cleared_date',
                  filterable: true,
                  fpFieldType:"date",
                  hidden:false,
                  filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "MM/DD/YYYY", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                  }
                },
                {
                  label: "Cleared Amount",
                  field: "cleared_amount",
                  fpFieldType:"integer",
                  filterable: true,
                  type:'number',
                  hidden:false,
                  filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Cleared Amount", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                  }
                },
                {
                  label: "Year Clrd",
                  field: "year",
                  filterable: true,
                  fpFieldType:"text",
                  hidden:false,
                  filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Cleared Year", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                  }
                },
                {
                  label: "Prd Clrd",
                  field: "month",
                  filterable: true,
                  fpFieldType:"text",
                  hidden:false,
                  filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Cleared Period", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                  }
                },
                {
                  label: 'Void Date',
                  field: 'void_date',
                  filterable: true,
                  fpFieldType:"date",
                  hidden:false,
                  filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "MM/DD/YYYY", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                  }
                },
                {
                  label: "Void Amount",
                  field: "void_amount",
                  fpFieldType:"integer",
                  filterable: true,
                  type:'number',
                  hidden:false,
                  filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Void Amount", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                  }
                },
                {
                  label: "Vendor Type",
                  field: "vendor_type",
                  fpFieldType:"text",
                  filterable: true,
                  hidden:false,
                  filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Vendor Type", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                  }
                },
                {
                  label: "Assignee Number",
                  field: "assignee_code",
                  filterable: true,
                  fpFieldType:"text",
                  hidden:false,
                  filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Payment Number", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                  }
                },
            ],
            rows: [],
            totalRecords: 0,
            cantAccessPage:"",
            loading:false,
            flag:"",
            listFlag:"",
            canPay:false,
            path:'',
            disButton:false,
            selectedPaymentId:"",
            vendorPaymentIdArr:[],
            selectedStatus:"",
            canView:false,
            reason:"",
            reason_error_msg:"",
            showConfirmBtn:false,
            showReassignBtn:false,
            showRemoveBtn:false,
            showCancelBtn:false,
            canViewLog:false,
            userArr:[],
            paymentTagsArr:[],
            payment_tag:"",
            showTagSearchField:true,
            tag_input:"",
            tag_input_error_msg:"",
            fieldArr:[],
            dateUpdate:false,
            tagUpdate:false,
            optionsDate: {
                format: 'MM/DD/YYYY',
                useCurrent: true,
            },
            optionsMonths:{
                format: 'MM/YYYY',
                useCurrent: true,
            },
            payment_date:'',
            payment_date_error:'',
            paymentListClass:'',
            showPaymentTagSection:false,
            tagsTotalRecords:0,
            paymentTagsRows:[],
            tagPage:1,
            tagPerPage:10,
            increasePage:5,
            tag_input_left:"",
            tag_input_left_error_msg:"",
            search_input_left:"",
            search_input_left_error_msg:"",
            over: false,
            currentIndex:0,
            currentPaymentTag:"",
            currentData:"",
            dragHoverValue:true,
            isDraggable:true,
            currentTag:"",
            defaultClass:true,
            showResetBtn:false,
            month:'',
            month_error_msg:'',
            showPrintBtn:false,
            showSendEmailBtn:false,
            showCloseBtn:false,
            action:'list',
            pageKey:"_vendor_payment_list",
            batchProcess:0,
            batchNum:"",
        }),
        watch: {

            permissions: function(permission){
                var self = this;
                permission.forEach(function (permissions) {
                    if(permissions.name == 'list_vendor_payment') {
                        self.cantAccessPage = true;
                    }
                    if(permissions.name == 'make_vendor_payment') {
                        self.canPay = true;
                    }
                    if(permissions.name == 'view_vendor_payment') {
                        self.canView = true;
                    }
                    if (permissions.name == 'view_activity_log') {
                        self.canViewLog = true;
                    }
                });
                if(self.cantAccessPage == ''){
                    self.cantAccessPage = false;
                }
            },
        },

        mounted: function() {

            var self = this;
            // self.path = process.env.FOLDER_URL;
            this.getPermissions();
            self.closeCheckPreview();
        },
        methods: {
            hideAssigneeModal() {
                var self = this;
                // self.change_assignee = "";
                // self.assignee_error_msg = "";
                // self.assigneeArr = [];
                // self.billIdArr = [];
                $("#change-assignee-modal").modal("hide");
            },
            cancelAll: function (cancelAll) {
              this.$refs.listVendorPaymentTable.unselectAllInternal();
            },

            onSearchPaymentTag(search, loading) {
                var self = this;
                if (search.length > 1) {
                    loading(true);
                    self.searchField(loading, search, 'payment tags', '');
                }
            },
            exportCheck: function() {
                var self = this;
                var count = 0;
                var actionFlag = "";
                var data = this.$refs['listVendorPaymentTable'].selectedRows;
                count = data.length;

                if(count != 0 && count < 100){
                  actionFlag = "export";
                }

                this.exportReports(actionFlag);
            },

            openCheckPreview(status,payment_id,file_path,check_type) {
                var self = this;
                self.path = "";

                // self.$router.push('/vendor-payment/preview/'+payment_id+'?status='+status);

                var url = '&payment_id='+payment_id+'&status='+status+'&type='+check_type;

                        // self.$router.push()
                self.$router.push({ name: 'VendorPaymentPreview', query: { data : btoa(url) }});

            },
            closeCheckPreview(){
                var self = this;
                $( "#check-detail-section" ).animate({
                        right: "-900px",
                    }, 300 );
                self.selectedPaymentId = "";
                self.selectedStatus = "";
                self.vendorPaymentIdArr = [];
            },
            loadList() {
                var self = this;

                var rowData = self.$refs['listVendorPaymentTable'].selectedRows;
                var use = [];
                var statusArr = [];

                for(var i = 0;i < rowData.length; i++){
                    use.push(rowData[i].id);
                }
                self.loading = true;
                var updateTag = '';
                if (self.tagUpdate == true){
                    updateTag = 'true';
                }else{
                    updateTag = 'false';
                }

                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                    flag:self.listFlag,
                    action:self.action,
                    all:self.serverParams.selectedAll,
                    id:use,
                    payment_date:self.payment_date,
                    tag:self.payment_tag,
                    tagflag:updateTag
                };
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/vendor-payment/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;

                        // console.log(data);
                        if ( data.status == "success" ) {
                        if ( self.action == "export" ||  self.action == "export_queue") {
                          if ( data.code == "201" ) {
                              alert(data.message);
                          } else {
                              if ( self.action == "export" ) {
                                  self.excel = data.content.web;
                                  var save = document.createElement("a");
                                  save.href = self.excel;
                                  save.download = data.content.web;
                                  save.target = "_blank";

                                  document.body.appendChild(save);
                                  save.click();
                                  document.body.removeChild(save);

                              } else {

                                  self.batchProcess = 1;
                                  self.batchNum = data.content;
                              }
                          }
                          self.action = "list";
                          self.loadList();

                        }else if (self.action == 'tag_update' || self.action == 'date_update'){

                                if (data.code == 201){
                                    $("#updatePaymentModal").modal("hide");
                                    self.action = 'list';
                                    self.$refs.filterPaymentList.clearSelectAll();
                                    self.cancelAll(true);
                                    self.loadList();
                                    self.$swal('',data.message,'info');
                                    self.loadPaymentTagList();
                                }else{
                                    self.action = 'list';
                                    self.$refs.filterPaymentList.clearSelectAll();
                                    self.cancelAll(true);
                                    self.loadList();
                                    $("#updatePaymentModal").modal("hide");
                                    self.tagUpdate = false;
                                    self.dateUpdate = false;
                                    self.payment_date = '';
                                    self.payment_date_error = '';
                                    self.payment_tag = '';
                                    self.loadPaymentTagList();
                                }

                        }else if(self.action == 'remove_tag'){

                            self.action = 'list';
                            self.$refs.filterPaymentList.clearSelectAll();
                            self.cancelAll(true);
                            self.loadList();
                            self.loadPaymentTagList();
                        }else if(self.action == 'close_payment'){
                            self.action = 'list';
                            self.$swal('',data.message,'success');
                            self.$refs.filterPaymentList.clearSelectAll();
                            self.cancelAll(true);
                            self.loadList();

                        }else if ( self.listFlag == "positivePay" ) {

                            if (data.code == 201){
                                self.$swal('','No Data With Printed or Void Status found','info');
                                return;
                            }else{
                                var excel = data.content;
                                var save = document.createElement("a");
                                save.href = excel;
                                save.download = data.content;
                                save.target = "_blank";
                                document.body.appendChild(save);
                                save.click();
                                document.body.removeChild(save);
                            }
                        } else {

                            self.rows = data.content.row;
                            self.totalRecords = data.content.totalRecords;
                            self.filteredFlag = false;
                        }


                        }
                        self.listFlag = "";
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.listFlag = "";
                        self.generateStatusCodeMessage(jqXHR,false,'vendor-payment-list');
                    }
                });
            },
            changePaymentStatus() {
                var self = this;
                var rowData = self.$refs['listVendorPaymentTable'].selectedRows;
                self.vendorPaymentIdArr = [];
                var statusArr = [];

                for(var i = 0;i < rowData.length; i++){
                    self.vendorPaymentIdArr.push(rowData[i].id);
                    statusArr.push(rowData[i].status);
                }

                //check all values in array are equal or not
                const allEqual = arr => arr.every( v => v === arr[0] );
                var found = allEqual(statusArr);

                if (found) {
                    self.selectedStatus = statusArr[0].toLowerCase();

                    if (self.selectedStatus == 'confirmed') {
                        self.selectedStatus = "";
                        self.vendorPaymentIdArr = [];
                        self.$swal('',"Vendor Payments with Confirmed status cannot be changed.",'info');
                    }else if(self.selectedStatus == 'void') {
                        self.selectedStatus = "";
                        self.vendorPaymentIdArr = [];
                        self.$swal('',"Vendor Payments with Voided status cannot be changed.",'info');
                    }else{
                        $("#change-status-modal").modal("show");
                    }
                }else{
                    self.selectedStatus = "";
                    self.vendorPaymentIdArr = [];
                    self.$swal('',"Please select Vendor Payments with same status.",'info');
                }
            },
            hideModal(){
                var self = this;
                $("#change-status-modal").modal("hide");
                self.selectedStatus = "";
                self.vendorPaymentIdArr = [];
            },
            ReassignPayment() {
              var self = this;
              var rowData = self.$refs['listVendorPaymentTable'].selectedRows;
                var data = [];
                var statusArr = [];
                for(var i = 0;i < rowData.length; i++){
                    data.push(rowData[i].id);
                }
                console.log("data ===", data);
                // /

                $.ajax({
                        url: process.env.ROOT_API + "/vendor-payment/reassign",
                        type: "POST",
                        data: {
                          payments: data,
                          reason: self.reason
                          },
                        headers: this.ajxHeaders,
                        dataType: "json",
                        success: function (data) {
                            self.loading = false;

                            if (data.status == "success") {
                                self.hideReasonModal();
                                self.$swal('','Vendor Payments Reassigned Successfully.','success');
                                self.cancelAll(true);
                                self.loadList();
                            }else{
                                if (flag == "list") {
                                    $("#confirmPaymentBtn").prop("disabled", false);
                                    $("#deletePaymentBtn").prop("disabled", false);
                                } else if (flag == "reason") {
                                    $("submitReasonBtn").prop("disabled",false);

                                } else{
                                    $("#confirmStatusBtnPreview").prop("disabled", false);
                                    $("#cancelStatusBtnPreview").prop("disabled", false);
                                }
                            }
                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            self.generateStatusCodeMessage(jqXHR,true,'change-payment-status');
                        }
                    });
            },
            changeStatus(flag,status) {
                var self = this;
                var newStatus = status;

                // if ( self.selectedPaymentId != "" ) {

                    if (flag == "list") {
                        $("#confirmPaymentBtn").prop("disabled", true);
                        $("#deletePaymentBtn").prop("disabled", true);
                    } else if(flag == "reason") {
                        $("submitReasonBtn").prop("disabled",true);
                    } else {
                        $("#confirmStatusBtnPreview").prop("disabled", true);
                        $("#cancelStatusBtnPreview").prop("disabled", true);
                    }

                    self.loading = true;
                    if (newStatus == "confirmed" ) {
                        var fields = {
                            arr:self.vendorPaymentIdArr,
                            status:newStatus,
                        }
                    }else{
                        var fields = {
                            arr:self.vendorPaymentIdArr,
                            status:newStatus,
                            reason:self.reason
                        }
                    }

                    $.ajax({
                        url: process.env.ROOT_API + "/vendor-payment/change-status",
                        type: "POST",
                        data: fields,
                        headers: this.ajxHeaders,
                        dataType: "json",
                        success: function (data) {
                            self.loading = false;

                            if (flag == "list") {
                                $("#confirmPaymentBtn").prop("disabled", false);
                                $("#deletePaymentBtn").prop("disabled", false);
                            } else if (flag == "reason") {
                                $("submitReasonBtn").prop("disabled",false);

                            } else{
                                $("#confirmStatusBtnPreview").prop("disabled", false);
                                $("#cancelStatusBtnPreview").prop("disabled", false);
                            }

                            if (data.status == "success") {

                                if (flag == "list") {
                                    // self.hideModal();
                                    self.$swal('','Vendor Payments Status Updated Successfully.','success');
                                } if ( flag == "reason") {
                                    self.hideReasonModal();
                                    self.closeCheckPreview();
                                    self.$swal('','Vendor Payments Status Updated Successfully.','success');
                                } else {
                                    self.closeCheckPreview();
                                    self.$swal('','Vendor Payment Status Updated Successfully.','success');
                                }
                                self.cancelAll(true);
                                self.loadList();
                            }else{
                                if (flag == "list") {
                                    $("#confirmPaymentBtn").prop("disabled", false);
                                    $("#deletePaymentBtn").prop("disabled", false);
                                } else if (flag == "reason") {
                                    $("submitReasonBtn").prop("disabled",false);

                                } else{
                                    $("#confirmStatusBtnPreview").prop("disabled", false);
                                    $("#cancelStatusBtnPreview").prop("disabled", false);
                                }
                            }
                        },
                        error: function (jqXHR, exception) {
                            if (flag == "list") {
                                $("#confirmPaymentBtn").prop("disabled", false);
                                $("#deletePaymentBtn").prop("disabled", false);
                            }else if (flag == "reason") {
                                $("submitReasonBtn").prop("disabled",false);

                            }else{
                                $("#confirmStatusBtnPreview").prop("disabled", false);
                                $("#cancelStatusBtnPreview").prop("disabled", false);
                            }
                            self.loading = false;
                            self.generateStatusCodeMessage(jqXHR,true,'change-payment-status');
                        }
                    });
                // }
            },

            removePayment(flag) {
                var self = this;
              if (confirm('Are you sure that you want to remove this Vendor Payment?')) {
                if (flag == "list") {
                    $("#confirmPaymentBtn").prop("disabled", true);
                    $("#deletePaymentBtn").prop("disabled", true);
                }else{
                    $("#confirmStatusBtnPreview").prop("disabled", true);
                    $("#cancelStatusBtnPreview").prop("disabled", true);
                }
                self.loading = true;
                $.ajax({
                    url: process.env.ROOT_API + "/vendor-payment/delete",
                    type: "POST",
                    data: {id:self.vendorPaymentIdArr},
                    headers: this.ajxHeaders,
                    dataType: 'json',
                    success: function (data) {
                        self.loading = false;
                        if (flag == "list") {
                            $("#confirmPaymentBtn").prop("disabled", false);
                            $("#deletePaymentBtn").prop("disabled", false);
                        }else{
                            $("#confirmStatusBtnPreview").prop("disabled", false);
                            $("#cancelStatusBtnPreview").prop("disabled", false);
                        }
                        if (data.status == "success") {

                            if (flag == "list") {

                                self.$swal('','Vendor Payments Removed Successfully.','success');
                            }else{
                                self.closeCheckPreview();
                                self.$swal('','Vendor Payment Removed Successfully.','success');
                            }
                            self.cancelAll(true);
                            self.loadList();
                            self.loadPaymentTagList();
                        }else{
                            if (flag == "list") {
                                $("#confirmPaymentBtn").prop("disabled", false);
                                $("#deletePaymentBtn").prop("disabled", false);
                            }else{
                                $("#confirmStatusBtnPreview").prop("disabled", false);
                                $("#cancelStatusBtnPreview").prop("disabled", false);
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (flag == "list") {
                            $("#confirmPaymentBtn").prop("disabled", false);
                            $("#deletePaymentBtn").prop("disabled", false);
                        }else{
                            $("#confirmStatusBtnPreview").prop("disabled", false);
                            $("#cancelStatusBtnPreview").prop("disabled", false);
                        }
                        self.generateStatusCodeMessage(jqXHR,true,'payment-delete');
                    }
                });
              }
            },
            openReasonModal(action) {
                var self = this;
                self.commentFor = action;
                $("#void-reason-modal").modal("show");
                console.log(self.selectedStatus);
                console.log(self.vendorPaymentIdArr);
            },
            hideReasonModal(){
                var self = this;
                $("#void-reason-modal").modal("hide");
                self.selectedStatus = "";
                self.vendorPaymentIdArr = [];
                self.reason = "";
                self.reason_error_msg = "";
            },
            submitReason() {
                var self = this;
                var error = false;

                if(self.commentFor == 'reassign') {
                  // console.log("comment ===", self.reason);

                  self.ReassignPayment();
                } else {
                  self.reason_error_msg = "";

                  if(self.reason == "" || !self.reason){
                      self.reason_error_msg = "Reason Required.";
                      error = true;
                  }

                  if(self.reason.trim() == ""){
                      self.reason_error_msg = "Reason Required.";
                      error = true;
                  }

                  if(!error){
                      self.changeStatus('reason','void');
                  }
                }


            },
            selectionChanged:function(param){
                var self = this;

                var rowData = self.$refs['listVendorPaymentTable'].selectedRows;
                var statusArr = [];
                self.vendorPaymentIdArr = [];
                self.showConfirmBtn = false;
                self.showReassignBtn = false;
                self.showRemoveBtn = false;
                self.showCancelBtn = false;
                self.showPrintBtn = false;
                self.showSendEmailBtn = false;
                self.showCloseBtn = false;
                if ( rowData.length > 0){
                    for(var i = 0; i < rowData.length; i++){

                        statusArr.push(rowData[i].status);
                        self.vendorPaymentIdArr.push(rowData[i].id);

                        if ( rowData[i].status == "Printed" || rowData[i].status == "Confirmed") {
                            self.showReassignBtn = true;
                        } else {
                            self.showReassignBtn = false;
                        }
                    }

                    //check all values in array are equal or not
                    const allEqual = arr => arr.every( v => v === arr[0] );
                    var found = allEqual(statusArr);
                    if ( found ) {
                        self.selectedStatus = statusArr[0].toLowerCase();
                        //show make payment button only if status is approved
                        if ( self.selectedStatus == "pending" ) {
                            self.showConfirmBtn = true;
                            self.showRemoveBtn = true;
                            // self.showReassignBtn = true;
                        }else if ( self.selectedStatus == "confirmed") {
                            self.showCancelBtn = true;
                            self.showPrintBtn = true;
                            // self.showReassignBtn = true;
                            self.showSendEmailBtn = true;
                        }else if ( self.selectedStatus == "printed") {
                            self.showCloseBtn = true;
                            self.showCancelBtn = true;
                            // self.showReassignBtn = true;
                        }
                        // else if ( self.selectedStatus == "printed" || self.selectedStatus == "confirmed") {
                        //     // self.showReassignBtn = true;
                        // }
                        // else {
                        //   self.showReassignBtn = false;
                        // }
                        console.log("STATIS ===", self.selectedStatus);

                    }
                }

                self.serverParams.selectedAll = false;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                // console.log(self.computed.selectedRows);
                var rowData = self.$refs['listVendorPaymentTable'].selectedRows;
                // console.log(rowData);
            },
            getActivityLogInfo(logId){
                var self = this;
                self.loading = true;
                self.fieldArr = [];

                $.ajax({
                    url: process.env.ROOT_API + "/payment/activitylog/info",
                    type: "GET",
                    data: {id:logId},
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {

                        console.log(data);
                        self.loading = false;
                        $("#paymentactivityLogViewModal").modal('show');

                        if (data.status == "success") {
                            self.fieldArr = data.content;
                            self.userArr = data.users;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'payment-activity');
                    }
                });

            },
            savePaymentTag() {
                var self = this;
                var error = false;
                self.tag_input_error_msg = "";

                if(self.tag_input == "" || !self.tag_input){
                    self.tag_input_error_msg = "Tag Name Required.";
                    error = true;
                }

                if(self.tag_input.trim() == ""){
                    self.tag_input_error_msg = "Tag Name Required.";
                    error = true;
                }

                if (!error) {
                    self.loading = true;
                    $("#btnSaveTagModal").prop("disabled",true);
                    $.ajax({
                        url: process.env.ROOT_API + "/payment-tag/create",
                        type: "POST",
                        data: {tag_name:self.tag_input},
                        headers: this.ajxHeaders,
                        dataType: "json",
                        success: function (data) {
                            self.loading = false;
                            $("#btnSaveTagModal").prop("disabled",false);
                            if (data.status == "success") {
                                console.log(data.content.text);
                                console.log(data.content.value);
                                self.payment_tag = {
                                    text:data.content.text,
                                    value:data.content.value
                                };
                                self.showTagSearchField = true;
                                self.tag_input = "";
                            } else {
                                if (data.content.length > 0) {
                                    var err = "";
                                    for (var i = 0; i < data.content.length; i++) {
                                        err += data.content[i] + "<br>";
                                        self.tag_input_error_msg += data.content[i] + "\n";
                                    }

                                    setTimeout(function () {
                                        self.tag_input_error_msg = "";
                                    }, 10000);
                                }
                            }
                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            $("#btnSaveTagModal").prop("disabled",false);
                            self.generateStatusCodeMessage(jqXHR,true,'payment-tag-create');
                        }
                    });
                }

            },
            ucStringValue(data) {
                var self = this;
                var string = (data != null || data != undefined)?data.toString().trim():'';

                if(string != ''){

                    var value = string.replace(/_/g, " ");

                    var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                        return letter.toUpperCase();
                    });
                    return upp;

                }else{
                    return '-';
                }

            },
            hidePaymentModal() {
                var self = this;
                $("#updatePaymentModal").modal("hide");
                self.showTagSearchField = true;
                self.payment_tag = "";
                self.tag_input = "";
                self.tag_input_error_msg = "";
                self.tagUpdate = false;
                self.dateUpdate = false;
                self.payment_date = '';
                self.payment_date_error = '';
            },
            openPaymentModal:function(flag){
                var self = this;
                $("#updatePaymentModal").modal("show");
                self.payment_date_error = '';
                self.payment_tag_error = '';
                if (flag == 'tag'){

                    self.tagUpdate = true;
                    self.updatePayment = 'Update Tag';

                }else{

                    self.dateUpdate = true;
                    self.updatePayment = 'Update Date';
                }
            },
            showTagInput() {
                var self = this;
                self.showTagSearchField = false;
                self.tag_input_error_msg = "";
            },
            removePaymentTag:function(){
                var self = this;

                var rowData = self.$refs['listVendorPaymentTable'].selectedRows;
                // var arr = [];
                var emptyTagCount = 0; // check whether payment with empty tag is selected or not

                for(var i = 0;i < rowData.length; i++){

                    // arr.push(rowData[i].id);
                    if (rowData[i].payment_tag == "" || rowData[i].payment_tag == null) {
                        emptyTagCount++;
                    }
                }

                if (emptyTagCount != rowData.length) {
                    self.action = 'remove_tag';
                    self.loadList();
                }else{
                    self.$swal('',"Tag already removed.",'info');
                }

                // $("#btnRemoveTagModal").prop("disabled",true);

                // $.ajax({
                //     url: process.env.ROOT_API + "/payment-tag/delete",
                //     type: "POST",
                //     data: {
                //         id:self.vendorPaymentIdArr
                //     },
                //     headers: {
                //         Accept: "application/json",
                //         "Authorization": "Bearer " + localStorage.getItem("tkn"),
                //         "Access-Control-Allow-Headers":
                //             "Origin, Content-Type, Authorization,X-Requested-With",
                //         "Cache-Control": "no-cache"
                //     },
                //     dataType: "json",
                //     success: function (data) {
                //         self.loading = false;
                //         $("#btnRemoveTagModal").prop("disabled",false);
                //         if (data.status == "success") {
                //             console.log(data.content.text);
                //             self.loadList();
                //             $("#updatePaymentModal").modal("hide");
                //             self.tagUpdate = false;
                //             self.dateUpdate = false;
                //             self.payment_date = '';
                //             self.payment_date_error = '';
                //             self.payment_tag = '';
                //             self.loadPaymentTagList();
                //         }
                //     },
                //     error: function (jqXHR, exception) {
                //         self.loading = false;
                //         $("#btnRemoveTagModal").prop("disabled",false);
                //         self.generateStatusCodeMessage(jqXHR,true,'payment-tag-delete');
                //     }
                // });

            },
            updatePaymentTag:function(){
                var self = this;

                var rowData = self.$refs['listVendorPaymentTable'].selectedRows;
                var arr = [];
                var error = false;
                var payment_tag = '';
                self.payment_date_error = '';
                self.payment_tag_error = '';
                for(var i = 0;i < rowData.length; i++){
                    arr.push(rowData[i].id);
                }

                if (self.dateUpdate === true && (self.payment_date == '' || self.payment_date == null)){

                    self.payment_date_error = 'Date Required';
                    error = true;
                }

                if (self.tagUpdate === true && (self.payment_tag == null || !self.payment_tag.value)){

                    self.payment_tag_error = 'No Tag Selected';
                    error = true;
                }

                if (self.payment_tag != null && self.payment_tag.value){
                    payment_tag = self.payment_tag.value;
                }

                var updateTag = '';
                if (self.tagUpdate == true){
                    updateTag = 'true';
                    self.action = 'tag_update';
                }else{
                    updateTag = 'false';
                    self.action = 'date_update';
                }

                if (!error){

                    self.loadList();
                //     $.ajax({
                //         url: process.env.ROOT_API + "/vendor-payment/update",
                //         type: "POST",
                //         data: {id:self.vendorPaymentIdArr,
                //         date:self.payment_date,
                //         tag:payment_tag,
                //         tagflag:updateTag},
                //         headers: {
                //             Accept: "application/json",
                //             "Authorization": "Bearer " + localStorage.getItem("tkn"),
                //             "Access-Control-Allow-Headers":
                //                 "Origin, Content-Type, Authorization,X-Requested-With",
                //             "Cache-Control": "no-cache"
                //         },
                //         dataType: "json",
                //         success: function (data) {
                //             self.loading = false;
                //             $("#btnSaveTagModal").prop("disabled",false);
                //             if (data.status == "success") {

                //                 self.loadList();
                //                 $("#updatePaymentModal").modal("hide");
                //                 self.tagUpdate = false;
                //                 self.dateUpdate = false;
                //                 self.payment_date = '';
                //                 self.payment_date_error = '';
                //                 self.payment_tag = '';
                //                 self.loadPaymentTagList();
                //             } else if (data.status == 'pending'){
                //                 self.$swal('',data.message,'info');
                //             }
                //         },
                //         error: function (jqXHR, exception) {
                //             self.loading = false;
                //             $("#btnSaveTagModal").prop("disabled",false);
                //             self.generateStatusCodeMessage(jqXHR,true,'payment-update');
                //         }
                //     });
                }
            },
            closePayment: function(){
                var self = this;

                var rowData = self.$refs['listVendorPaymentTable'].selectedRows;
                var arr = [];
                var error = false;
                for(var i = 0;i < rowData.length; i++){

                    // if (rowData[i].status != 'Confirmed' && rowData[i].status != 'confirmed'){
                    if (rowData[i].status != 'Printed' && rowData[i].status != 'printed'){
                        self.$swal('','Printed payment can be closed only','info');
                        error = true;
                    }

                    arr.push(rowData[i].id);
                }

                if (!error){
                    self.action = 'close_payment';
                    self.loadList();

                    // $("#closePaymentBtn").prop("disabled",true);

                    // $.ajax({
                    //     url: process.env.ROOT_API + "/vendor-payment/close",
                    //     type: "POST",
                    //     data: {id:self.vendorPaymentIdArr},
                    //     headers: {
                    //         Accept: "application/json",
                    //         "Authorization": "Bearer " + localStorage.getItem("tkn"),
                    //         "Access-Control-Allow-Headers":
                    //             "Origin, Content-Type, Authorization,X-Requested-With",
                    //         "Cache-Control": "no-cache"
                    //     },
                    //     dataType: "json",
                    //     success: function (data) {
                    //         self.loading = false;
                    //         $("#closePaymentBtn").prop("disabled",false);
                    //         if (data.status == "success") {
                    //             self.$swal('',data.message,'success');
                    //             self.loadList();
                    //         }
                    //     },
                    //     error: function (jqXHR, exception) {
                    //         self.loading = false;
                    //         $("#closePaymentBtn").prop("disabled",false);
                    //         self.generateStatusCodeMessage(jqXHR,true,'payment-close');
                    //     }
                    // });
                }
            },
            loadPaymentTagList(){
                var self = this;
                self.loading = true;
                var fields = {
                    page: self.tagPage,
                    perPage: self.tagPerPage,
                    filters: {
                        search:self.search_input_left
                    },
                    sort: {
                        field: 'updatedAt',
                        type: 'desc',
                    },
                };
                $.ajax({
                    url: process.env.ROOT_API + "/payment-tag/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        // console.log(data);
                        if (data.status == "success") {
                            self.paymentTagsRows = data.content.row;
                            self.tagsTotalRecords = data.content.totalRecords;
                            if (self.search_input_left != "") {
                                self.showResetBtn = true;
                                self.closeLeftPaymentTagSearch();
                            }
                            if(self.paymentTagsRows.length > 0) {
                                for(var i = 0;i<self.paymentTagsRows.length;i++) {
                                    //add active class on the basis of current tag
                                    if (self.currentTag != "") {
                                        if (self.currentTag.valueOf() == self.paymentTagsRows[i].tagId) {
                                            //self.paymentTagsRows[i].class = 'list-detail-section active';
                                            self.$set(self.paymentTagsRows[i], 'setActive', true);
                                            self.$set(self.paymentTagsRows[i], 'setRed', false);
                                            self.$set(self.paymentTagsRows[i], 'setGreen', false);
                                            self.$set(self.paymentTagsRows[i], 'setOver', false);
                                            // self.paymentTagsRows[i].setActive = true;
                                            // self.paymentTagsRows[i].setRed = false;
                                            // self.paymentTagsRows[i].setGreen = false;
                                            // self.paymentTagsRows[i].setOver = false;
                                        } else {
                                            //self.paymentTagsRows[i].class = 'list-detail-section';
                                            self.$set(self.paymentTagsRows[i], 'setActive', false);
                                            self.$set(self.paymentTagsRows[i], 'setRed', false);
                                            self.$set(self.paymentTagsRows[i], 'setGreen', false);
                                            self.$set(self.paymentTagsRows[i], 'setOver', false);
                                            // self.paymentTagsRows[i].setActive = false;
                                            // self.paymentTagsRows[i].setRed = false;
                                            // self.paymentTagsRows[i].setGreen = false;
                                            // self.paymentTagsRows[i].setOver = false;
                                        }

                                    } else {
                                        //default tag item class
                                        //self.paymentTagsRows[i].class = 'list-detail-section';
                                        self.$set(self.paymentTagsRows[i], 'setActive', false);
                                        self.$set(self.paymentTagsRows[i], 'setRed', false);
                                        self.$set(self.paymentTagsRows[i], 'setGreen', false);
                                        self.$set(self.paymentTagsRows[i], 'setOver', false);
                                        // self.paymentTagsRows[i].setActive = false;
                                        // self.paymentTagsRows[i].setRed = false;
                                        // self.paymentTagsRows[i].setGreen = false;
                                        // self.paymentTagsRows[i].setOver = false;
                                    }
                                }
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'payment-tag-list');
                    }
                });
            },
            openPaymentTagDiv() {

                var self = this;
                self.loadPaymentTagList();
                self.paymentListClass = 'col-md-9 custom-scrollbar fl-payment-block';
                self.showPaymentTagSection = true;
                self.showResetBtn = false;

                setTimeout(function () {
                    $('.fl-payment-block').height($(window).height() - 210);
                    $(window).resize(function() {$('.fl-payment-block').height($(window).height() - 210);})
                    $('.cashflow-listing-fl').height($(window).height() - 235);
                    $(window).resize(function() {$('.cashflow-listing-fl').height($(window).height() - 235);})
                },1000);

            },
            hidePaymentTagDiv(){
                var self = this;
                self.showPaymentTagSection = false;
                self.paymentListClass = '';
                self.$refs.paginateComponent.showCashflowButton();
                self.showResetBtn = false;

                for(var i = 0; i < self.userColumns.length;i++){

                    if (self.userColumns[i].field == "confirm_by"){
                        self.$set(self.userColumns[i], 'hidden', false);
                    }
                    if (self.userColumns[i].field == "processed_by"){
                        self.$set(self.userColumns[i], 'hidden', false);
                    }
                }
            },
            openLeftPaymentTagAdd(){
                var self = this;
                if($("#searchPaymentTagLeft").hasClass("show")) {
                    $("#searchPaymentTagLeft").removeClass("show");
                    $("#searchPaymentTagLeft").addClass("hide");
                    self.search_input_left = "";
                    self.search_input_left_error_msg = "";
                }
                $("#addPaymentTagLeft").toggleClass("show");
            },
            closeLeftPaymentTagAdd(){
                var self = this;
                $("#addPaymentTagLeft").removeClass("show");
                $("#addPaymentTagLeft").addClass("hide");
                self.tag_input_left = "";
                self.tag_input_left_error_msg = "";
            },
            openLeftPaymentTagSearch(){
                var self = this;
                if($("#addPaymentTagLeft").hasClass("show")) {
                    $("#addPaymentTagLeft").removeClass("show");
                    $("#addPaymentTagLeft").addClass("hide");
                    self.tag_input_left = "";
                    self.tag_input_left_error_msg = "";
                }
                $("#searchPaymentTagLeft").toggleClass("show");
            },
            closeLeftPaymentTagSearch(){
                var self = this;
                $("#searchPaymentTagLeft").removeClass("show");
                $("#searchPaymentTagLeft").addClass("hide");
                self.search_input_left = "";
                self.search_input_left_error_msg = "";
            },
            savePaymentTagLeft(){
                var self = this;
                var error = false;
                self.tag_input_left_error_msg = "";

                if(self.tag_input_left == "" || !self.tag_input_left){
                    self.tag_input_left_error_msg = "Tag Name Required.";
                    error = true;
                }

                if(self.tag_input_left.trim() == ""){
                    self.tag_input_left_error_msg = "Tag Name Required.";
                    error = true;
                }

                if (!error) {
                    self.loading = true;
                    $.ajax({
                        url: process.env.ROOT_API + "/payment-tag/create",
                        type: "POST",
                        data: {tag_name:self.tag_input_left},
                        headers: this.ajxHeaders,
                        dataType: "json",
                        success: function (data) {
                            self.loading = false;
                            if (data.status == "success") {
                                self.loadPaymentTagList();
                                self.closeLeftPaymentTagAdd();
                            } else {
                                if (data.content.length > 0) {
                                    var err = "";
                                    for (var i = 0; i < data.content.length; i++) {
                                        err += data.content[i] + "<br>";
                                        self.tag_input_left_error_msg += data.content[i] + "\n";
                                    }

                                    setTimeout(function () {
                                        self.tag_input_left_error_msg = "";
                                    }, 10000);
                                }
                            }
                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            self.generateStatusCodeMessage(jqXHR,true,'payment-tag-add');
                        }
                    });
                }
            },
            searchPaymentTagLeft(){
                var self = this;
                var error = false;
                self.search_input_left_error_msg = "";

                if(self.search_input_left == "" || !self.search_input_left){
                    self.search_input_left_error_msg = "Tag Name Required.";
                    error = true;
                }

                if(self.search_input_left.trim() == ""){
                    self.search_input_left_error_msg = "Tag Name Required.";
                    error = true;
                }

                if (!error) {
                    self.loadPaymentTagList();
                }
            },
            loadMoreData(){
                var self = this;
                self.tagPerPage += self.increasePage;
                self.loadPaymentTagList();
            },
            handleDragStart(data) {
                var self = this;
                console.log("handleDragStart");
                //console.log(JSON.stringify(data));
                self.currentData = data;
                self.dragHoverValue = true;
                //self.isDraggable = true;
            },
            handleDragEnd(data){

                var self = this;
                console.log("handleDragEnd");

                self.dragHoverValue = true;
                //self.isDraggable = false;
                //add active class on tag item on the basis of current tag
                if (self.currentTag != "") {
                    for(var i = 0;i<self.paymentTagsRows.length;i++) {

                        if (self.currentTag.valueOf() == self.paymentTagsRows[i].tagId) {

                            //self.paymentTagsRows[i].class = 'list-detail-section active';
                            //self.paymentTagsRows[i].setActive = true;
                            this.$set(self.paymentTagsRows[i], 'setActive', true);
                        } else {

                            //self.paymentTagsRows[i].class = 'list-detail-section';
                            //self.paymentTagsRows[i].setActive = false;
                            this.$set(self.paymentTagsRows[i], 'setActive', false);
                        }

                        this.$set(self.paymentTagsRows[i], 'setRed', false);
                        this.$set(self.paymentTagsRows[i], 'setGreen', false);
                        this.$set(self.paymentTagsRows[i], 'setOver', false);
                        // self.paymentTagsRows[i].setRed = false;
                        // self.paymentTagsRows[i].setGreen = false;
                        // self.paymentTagsRows[i].setOver = false;
                    }
                }
            },
            handleDragEnter(){
                var self = this;
                console.log("handleDragEnter");
                // self.dragHoverValue = true;
            },
            handleDrop(data) {
                var self = this;
                self.over = false;
                console.log(self.currentIndex);
                console.log("handleDrop");
                //console.log(JSON.stringify(data));
                //console.log(data);
                self.dragHoverValue = true;
                if (data.status.toLowerCase() == "pending") {
                    for(var i = 0;i<self.paymentTagsRows.length;i++) {
                        if ( self.currentIndex == i ) {
                            //check current payment in Tag Data
                            if (!self.paymentTagsRows[i].payments.includes(data.id.toString())) {
                                    //set current tag value
                                    self.currentTag = self.paymentTagsRows[i].tagId;
                                    self.vendorPaymentIdArr = [];
                                    self.vendorPaymentIdArr.push(data.id);
                                    var updateTag = 'true';
                                    var payment_tag = self.paymentTagsRows[i].tagId;
                                    self.payment_date = "";
                                    self.loading = true;
                                    $.ajax({
                                        url: process.env.ROOT_API + "/vendor-payment/update",
                                        type: "POST",
                                        data: {id:self.vendorPaymentIdArr,
                                        date:self.payment_date,
                                        tag:payment_tag,
                                        tagflag:updateTag},
                                        headers: this.ajxHeaders,
                                        dataType: "json",
                                        success: function (data) {
                                            self.loading = false;
                                            if (data.status == "success") {
                                                self.tagUpdate = false;
                                                self.dateUpdate = false;
                                                self.loadPaymentTagList();
                                                self.loadList();

                                            } else if (data.status == 'pending') {

                                                //self.paymentTagsRows[self.currentIndex].class = 'list-detail-section';

                                                self.$set(self.paymentTagsRows[self.currentIndex], 'setActive', false);
                                                self.$set(self.paymentTagsRows[self.currentIndex], 'setRed', false);
                                                self.$set(self.paymentTagsRows[self.currentIndex], 'setGreen', false);
                                                self.$set(self.paymentTagsRows[self.currentIndex], 'setOver', false);
                                                // self.paymentTagsRows[self.currentIndex].setActive = false;
                                                // self.paymentTagsRows[self.currentIndex].setRed = false;
                                                // self.paymentTagsRows[self.currentIndex].setGreen = false;
                                                // self.paymentTagsRows[self.currentIndex].setOver = false;
                                                self.$swal('',data.message,'info');
                                            }
                                        },
                                        error: function (jqXHR, exception) {
                                            self.loading = false;
                                            self.generateStatusCodeMessage(jqXHR,true,'payment-tag-edit');
                                        }
                                    });
                            } else {

                                self.$set(self.paymentTagsRows[self.currentIndex], 'setActive', false);
                                self.$set(self.paymentTagsRows[self.currentIndex], 'setRed', false);
                                self.$set(self.paymentTagsRows[self.currentIndex], 'setGreen', false);
                                self.$set(self.paymentTagsRows[self.currentIndex], 'setOver', false);
                                // self.paymentTagsRows[self.currentIndex].setActive = false;
                                // self.paymentTagsRows[self.currentIndex].setRed = false;
                                // self.paymentTagsRows[self.currentIndex].setGreen = false;
                                // self.paymentTagsRows[self.currentIndex].setOver = false;
                                var message = "Payment " + data.payment_number + " already have Tag " + data.payment_tag;
                                self.$swal('',message,'info');
                                return;
                            }

                        } else {
                            //self.paymentTagsRows[i].class = 'list-detail-section';

                            self.$set(self.paymentTagsRows[i], 'setActive', false);
                            self.$set(self.paymentTagsRows[i], 'setRed', false);
                            self.$set(self.paymentTagsRows[i], 'setGreen', false);
                            self.$set(self.paymentTagsRows[i], 'setOver', false);
                            // self.paymentTagsRows[i].setActive = false;
                            // self.paymentTagsRows[i].setRed = false;
                            // self.paymentTagsRows[i].setGreen = false;
                            // self.paymentTagsRows[i].setOver = false;
                        }
                    }
                } else {

                    console.log("handle drag end else");
                    //self.paymentTagsRows[self.currentIndex].class = 'list-detail-section';

                    // self.paymentTagsRows[self.currentIndex].setActive = false;
                    // self.paymentTagsRows[self.currentIndex].setRed = false;
                    // self.paymentTagsRows[self.currentIndex].setGreen = false;
                    // self.paymentTagsRows[self.currentIndex].setOver = false;

                    this.$set(self.paymentTagsRows[self.currentIndex], 'setActive', false);
                    this.$set(self.paymentTagsRows[self.currentIndex], 'setRed', false);
                    this.$set(self.paymentTagsRows[self.currentIndex], 'setGreen', false);
                    this.$set(self.paymentTagsRows[self.currentIndex], 'setOver', false);
                    self.$swal('',"You can only update payment with pending status",'info');
                    return;
                }
            },
            handleDragOver(tagdata,index) {
                var self = this;

                if (self.dragHoverValue == true){
                    console.log("handleDragOver" + index);
                    self.currentIndex = index;
                    self.dragHoverValue = false;
                    // self.currentPaymentTag = tagdata;
                    //console.log(JSON.stringify(tagdata));
                    console.log("id :: tag-item"+ tagdata.tagId);

                    //set highlight tag class on current tag item when drag over
                    this.$set(self.paymentTagsRows[index], 'oldPaymentValue', self.paymentTagsRows[index].totalPayments);
                    this.$set(self.paymentTagsRows[index], 'oldVendorValue', self.paymentTagsRows[index].totalVendor);
                    this.$set(self.paymentTagsRows[index], 'oldAmount', self.paymentTagsRows[index].amount);
                    this.$set(self.paymentTagsRows[index], 'oldPayments', self.paymentTagsRows[index].payments);
                    this.$set(self.paymentTagsRows[index], 'oldVendors', self.paymentTagsRows[index].vendors);


                    if ( self.currentData.status.toLowerCase() == "pending" ) {
                        //check current payment in Tag Data
                        if (!self.paymentTagsRows[index].payments.includes(self.currentData.id.toString())) {
                            //self.paymentTagsRows[index].totalPayments = self.paymentTagsRows[index].totalPayments + 1;
                            this.$set(self.paymentTagsRows[index], 'totalPayments', self.paymentTagsRows[index].totalPayments + 1);
                            var formatAmount = parseFloat(String(self.paymentTagsRows[index].amount)) + parseFloat(String(self.currentData.payment_amount));
                            //self.paymentTagsRows[index].totalAmount = self.amountFormat(formatAmount);
                            this.$set(self.paymentTagsRows[index], 'totalAmount', self.amountFormat(formatAmount));
                            //check vendor id
                            if (!self.paymentTagsRows[index].vendors.includes(self.currentData.vendor_id.toString())) {
                                this.$set(self.paymentTagsRows[index], 'totalVendor', self.paymentTagsRows[index].totalVendor + 1)
                                //self.paymentTagsRows[index].totalVendor = self.paymentTagsRows[index].totalVendor + 1;
                            }

                            this.$set(self.paymentTagsRows[index], 'setActive', false);
                            this.$set(self.paymentTagsRows[index], 'setRed', false);
                            this.$set(self.paymentTagsRows[index], 'setGreen', true);
                            this.$set(self.paymentTagsRows[index], 'setOver', true);

                        } else {
                            console.log("Pending inside else" + index);

                            this.$set(self.paymentTagsRows[index], 'setActive', false);
                            this.$set(self.paymentTagsRows[index], 'setRed', true);
                            this.$set(self.paymentTagsRows[index], 'setGreen', false);
                            this.$set(self.paymentTagsRows[index], 'setOver', true);
                        }

                    } else {

                        console.log("en else Pending Main IF" + index);
                        this.$set(self.paymentTagsRows[index], 'setActive', false);
                        this.$set(self.paymentTagsRows[index], 'setRed', true);
                        this.$set(self.paymentTagsRows[index], 'setGreen', false);
                        this.$set(self.paymentTagsRows[index], 'setOver', true);

                    }
                    console.log(self.paymentTagsRows[index]);
                }
            },
            handleDragLeave(tagdata,index) {

                var self = this;
                console.log("handleDragLeave" + index);
                self.dragHoverValue = true;
                self.currentIndex = index;
                console.log("id :: tag-item"+ tagdata.tagId);
                //remove highlight tag class from current tag item
                this.$set(self.paymentTagsRows[index], 'setActive', false);
                this.$set(self.paymentTagsRows[index], 'setRed', false);
                this.$set(self.paymentTagsRows[index], 'setGreen', false);
                this.$set(self.paymentTagsRows[index], 'setOver', false);

                this.$set(self.paymentTagsRows[index], 'totalPayments', self.paymentTagsRows[index].oldPaymentValue);
                this.$set(self.paymentTagsRows[index], 'totalVendor', self.paymentTagsRows[index].oldVendorValue);
                this.$set(self.paymentTagsRows[index], 'totalAmount', self.amountFormat(parseFloat(String(self.paymentTagsRows[index].oldAmount))));
                // self.paymentTagsRows[index].totalPayments = self.paymentTagsRows[index].oldPaymentValue;
                // self.paymentTagsRows[index].totalVendor = self.paymentTagsRows[index].oldVendorValue;
                // self.paymentTagsRows[index].totalAmount = self.amountFormat(parseFloat(String(self.paymentTagsRows[index].oldAmount)));
                self.over = false;
            },
            amountFormat(amount) {

                return amount.toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD'
                });
            },
            onTagClick(tagName,index) {
                var self = this;
                self.$refs.filterPaymentList.paymentTagFilters(tagName);
            },
            resetTagList(){
                var self = this;
                self.loadPaymentTagList();
                self.showResetBtn = false;
            },
            openMultipleCheckPreview() {
                var self = this;
                self.path = "";

                var url = '&payment_ids='+self.vendorPaymentIdArr+'&flag=all';

                self.$router.push({ name: 'VendorPaymentPreview', query: { data : btoa(url) }});
            },
            exportPayment: function() {
                var self = this;

                self.month_error_msg = '';
                if ( self.month == '' || self.month == null ) {
                    self.month_error_msg = 'Month required';
                    return;
                }

                var fields = {
                    filters: self.serverParams.columnFilters,
                    month:self.month
                };

                $.ajax({
                    url: process.env.ROOT_API + "/positive-payment/export",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;

                        if (data.code == 201){

                            self.month_error_msg = 'No data found for given month';
                        }
                        // console.log(data);
                        if (data.status == "success") {
                            var excel = data.content.web;
                            var save = document.createElement("a");
                            save.href = excel;
                            save.download = data.content.web;
                            save.target = "_blank";
                            document.body.appendChild(save);
                            save.click();
                            document.body.removeChild(save);


                            $("#positive-export-modal").modal("hide");
                            self.month = '';
                            self.month_error_msg = '';
                        }

                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'vendor-payment-list');
                    }
                });
            },
            openExportModal: function(){
                var self = this;
                self.listFlag = "positivePay";
                self.loadList();
                // $("#positive-export-modal").modal("show");
                // self.month = '';
                // self.month_error_msg = '';
            },
            hidePaymenExporttModal: function(){

                $("#positive-export-modal").modal("hide");
                self.month = '';
                self.month_error_msg = '';
            },
            sendConfirmedPayments: function(){
                var self = this;
                var rowData = self.$refs['listVendorPaymentTable'].selectedRows;
                var arr = [];
                for (var i = 0;i<rowData.length;i++) {
                    var payment_type = "";
                    if (rowData[i].check_type == "ach") {
                        payment_type = "ACH";
                    }else{
                        payment_type = "CHECK";
                    }

                    arr.push({
                        'payment_number':rowData[i].payment_number,
                        'payment_tag':rowData[i].payment_tag,
                        'check':rowData[i].cheque,
                        'payment_date':rowData[i].payment_date,
                        'vendor':rowData[i].vendor,
                        'payment_amount':rowData[i].amount,
                        'processed_by':rowData[i].processed_by,
                        'payment_type':payment_type
                    });
                }
                self.loading = true;
                $.ajax({
                    url: process.env.ROOT_API + "/confirmed-payments/send",
                    type: "POST",
                    data: {
                        "payments":arr
                    },
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        if (data.status == "success") {
                            self.$swal('','Confirmed Payments Sent Successfully.','success');
                            self.cancelAll(true);
                            self.loadList();
                        }

                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'send-vendor-payment');
                    }
                });

            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/payment/VendorPaymentList.vue